import axios from 'axios'

import { getBackendUrl } from '@/general'


export const descargarCotizacionPDF = async (context, idDocument) => {
    try {
      await context.$store.dispatch("statusLogin", context.$router)
      const { source } = await getBackendUrl()
      const res = await axios.get(
        `${source}/reportes/api/descargaPedidoPDF?ID=${idDocument}`,
        {
          headers: {
            'Authorization': `Bearer ${context.$store.state.user.token}`
          }
        }
      )
  
      return res.data
    } catch (error) {
      console.log(error);
      throw error.response
    }
  }

  export const imprimirSolicitudCompra = async (context, idDocument) => {
    try {
      await context.$store.dispatch("statusLogin", context.$router)
      const { source } = await getBackendUrl()
      const res = await axios.get(
        `${source}/reportes/api/descargaSolicitudCompraPDF?ID=${idDocument}`,
        {
          headers: {
            'Authorization': `Bearer ${context.$store.state.user.token}`
          }
        }
      )
  
      return res.data
    } catch (error) {
      console.log(error);
      throw error.response
    }
  }

  export const descargarFacturaElectronica = async (context, idDocument, typeDocument) => {
  try {
    await context.$store.dispatch("statusLogin", context.$router)
    const { source } = await getBackendUrl()
    const res = await axios.get(
      `${source}/reportes/api/descargaFacturaElectronica?ID=${idDocument}&Tipo=${typeDocument}`,
      {
        headers: {
          'Authorization': `Bearer ${context.$store.state.user.token}`
        }
      }
    )

    return res.data
  } catch(error) {
    console.log(error);
    throw error.response
  }
}

export const descargarSerialesDocumentoPDF = async(context, idDocument) => {
  try {
    await context.$store.dispatch("statusLogin", context.$router)
    const { source } = await getBackendUrl()
    const res = await axios.get(
      `${source}/reportes/api/descargaSerialesDocumentoPDF?ID=${idDocument}`,
      {
        headers: {
          "Authorization": `Bearer ${context.$store.state.user.token}`
        }
      }
    )

    return res.data
  } catch(error) {
    console.log(error);
    throw error.response
  }
}

export const descargaEstadoCuentaExcel = async (context, id, typeQuery, fileType) => {
  try {
    await context.$store.dispatch("statusLogin", context.$router)
    const { source } = await getBackendUrl()
    let parameters = {
      "ID": id,
      "Tipo": typeQuery,
      "Formato": fileType
    }
    const res = await axios.get(
      `${source}/reportes/api/descargaEstadoCuentaExcel`,
      {
        params: parameters,
        headers: {
          "Authorization": `Bearer ${context.$store.state.user.token}`
        }
      }
    )

    return res.data
  } catch(err) {
    console.log(err);
    throw err.response
  }
}

export const descargaConfiguracionContableProductosExcel = async (context, data) => {
  try {
    await context.$store.dispatch("statusLogin", context.$router);
    const { source } = await getBackendUrl();
    const res = await axios.post(
      `${source}/reportes/api/descargaConfiguracionContableProductosExcel`,
      data,
      {
        headers: {
          "Authorization": `Bearer ${context.$store.state.user.token}`
        }
      }
    );
    
    return res.data;
  } catch(err) {
    throw err.response;
  }
}

export const descargarCostosVentaProductosKitExcel = async (context, data) => {
  try {
    await context.$store.dispatch("statusLogin", context.$router);
    const { source } = await getBackendUrl();
    const res = await axios.post(
      `${source}/reportes/api/descargaCostosVentasProductosKitExcel`,
      data,
      {
        headers: {
          "Authorization": `Bearer ${context.$store.state.user.token}`
        }
      }
    );

    return res.data;
  } catch(err) {
    console.log(err);
    throw err.response;
  }
}

// export const enviarCotizacion = async (context, idDocument) => {
//     try {
//       await context.$store.dispatch('statusLogin', context.$router)
//       const { source } = await getBackendUrl()
//       const res = await axios.post(
//         `${source}/consultas/api/enviaCorreoCotizacion`,
//         {
//           Id_Documento: idDocument
//         },
//         {
//           headers: {
//             'Authorization': `Bearer ${context.$store.state.user.token}`
//           }
//         }
//       )
  
//       return res.data
//     } catch (err) {
//       console.log(err)
//       throw err.response
//     }
//   }

export const enviarEstadoCuenta = async (context, idDirectory, emailList) => {
  try {
    await context.$store.dispatch('statusLogin', context.$router)
    const { source } = await getBackendUrl()
    const res = await axios.post(
      `${source}/reportes/api/enviaCorreoEstadoCuenta?ID=${idDirectory}`,
      {
        Id_Cliente: idDirectory,
        CorreosElectronicos: emailList
      },
      {
        headers: {
          'Authorization': `Bearer ${context.$store.state.user.token}`
        }
      }
    )

    return res.data
  } catch (err) {
    console.log(err)
    throw err.response
  }
}
  